if (!customElements.get('facet-drawer')) {
  customElements.define('facet-drawer', class FacetDrawer extends MainDrawer {
    constructor() {
      super();                  
      
      this.setFocus = debounce((event) => {
        trapFocus(document.querySelector('.drawer--active'), document.querySelector('.drawer--active'))              
      }, 300);

      this.querySelectorAll('.drawer-close').forEach(el => el.addEventListener('click', () => this.closeDrawer()));    
      this.closest('.facet-container').querySelector('.facet__trigger').addEventListener('click', (e) => {        
        e.preventDefault()
        loadScript('facets')
        loadCss('facets')    
        this.openDrawer()      
        this.setFocus()
      });      
    }        
  });
}

// get the sticky element
const stickyElm = document.querySelector('.toolbar--sticky')

const stickyElementObserver = new IntersectionObserver( 
  ([e]) => {      
    if(e.intersectionRatio < 1){        
      e.target.classList.add('isSticky')        
    } else {        
      e.target.classList.remove('isSticky')
    }      
  },
  {threshold: [1]}
);

stickyElementObserver.observe(stickyElm)

// transparent header on top banner
window.addEventListener('DOMContentLoaded', () => {
  if(document.getElementsByClassName('top-banner').length){
    const header = document.querySelector('#shopify-section-header header');
    header.classList.add('header--color-light');
    // Toggle on scroll
    window.addEventListener('scroll', function() {
      if (window.scrollY >= 50) {
        header.classList.remove('header--color-light');
      } else {
        header.classList.add('header--color-light');
      }
    });
  }
})